import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function OldSolutionsFail() {
  return <section className="py-24 px-6 bg-bg-secondary border-y border-white/5" data-id="element-123">
      <div className="max-w-3xl mx-auto" data-id="element-124">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} data-id="element-125">
          <h2 className="text-3xl md:text-5xl font-serif text-text-primary mb-12 text-center" data-id="element-126">
            ¿Por qué el presupuesto típico no te sirve?
          </h2>

          <div className="space-y-8 text-lg md:text-xl text-text-secondary leading-relaxed" data-id="element-127">
            <p data-id="element-128">Porque el presupuesto típico asume algo que no es verdad:</p>
            <p className="text-text-primary font-medium border-l-4 border-brand-gold pl-6 py-2 bg-brand-gold/5" data-id="element-129">
              Que tú vas a tomar decisiones perfectas… cuando estás cansada,
              ansiosa, con hambre, con estrés, con mil cosas encima.
            </p>
            <p data-id="element-130">
              Ese método depende de fuerza de voluntad. Y la fuerza de voluntad
              se acaba.
            </p>
            <p data-id="element-131">
              No porque seas débil.{' '}
              <span className="text-text-primary italic" data-id="element-132">
                Porque eres humana.
              </span>
            </p>
            <p data-id="element-133">
              Y porque hoy tu plata está expuesta a un diseño agresivo:
              domicilios, cuotas, tarjetas guardadas, notificaciones,
              algoritmos.
            </p>
          </div>

          <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-134">
            <div className="bg-bg-main p-6 rounded-xl border border-white/5 flex flex-col items-center text-center" data-id="element-135">
              <XCircle className="w-10 h-10 text-red-400 mb-4" data-id="element-136" />
              <h3 className="text-xl font-serif text-text-primary mb-2" data-id="element-137">
                Depende de tu voluntad
              </h3>
              <p className="text-text-secondary text-sm" data-id="element-138">
                Falla cuando estás cansada o vulnerable.
              </p>
            </div>
            <div className="bg-bg-main p-6 rounded-xl border border-white/5 flex flex-col items-center text-center" data-id="element-139">
              <XCircle className="w-10 h-10 text-red-400 mb-4" data-id="element-140" />
              <h3 className="text-xl font-serif text-text-primary mb-2" data-id="element-141">
                Es teórico, no real
              </h3>
              <p className="text-text-secondary text-sm" data-id="element-142">
                No ataca los gatillos emocionales ni el "un clic".
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}